export class SetShiftConfirmationId {
    public static readonly type = '[JobsPlacements] Set shift confirmation id';

    constructor(public shiftId: string | null, public shiftDate: string | null) { }
}
